var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25672_7336)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4784 2.92C19.3584 0.88 16.4384 0 11.9984 0C7.55844 0 4.63844 0.88 2.51844 2.92L2.39844 3.04V11.28V12C2.39844 17.48 6.19844 22.36 11.8784 24.12L11.9984 24.16L12.1184 24.12C17.7984 22.36 21.5984 17.48 21.5984 12V3.04L21.4784 2.92Z",
    fill: "#518EF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C15.3137 17 18 14.3137 18 11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11C6 14.3137 8.68629 17 12 17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25672_7336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 11,
    width: 12,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2523 23.1999C15.4077 23.1999 17.9656 20.642 17.9656 17.4867C17.9656 14.3313 15.4077 11.7734 12.2523 11.7734C9.09697 11.7734 6.53906 14.3313 6.53906 17.4867C6.53906 20.642 9.09697 23.1999 12.2523 23.1999Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25672_7336)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5816 9.30446L11.8476 13.319C11.7356 13.4394 11.5886 13.5 11.4415 13.5C11.2945 13.5 11.1474 13.4394 11.0354 13.319L9.1685 11.3117C8.94383 11.0703 8.94383 10.6799 9.1685 10.4384C9.39306 10.1968 9.75607 10.1968 9.98075 10.4384L11.4415 12.009L14.7694 8.43117C14.994 8.18961 15.3569 8.18961 15.5816 8.43117C15.8061 8.67261 15.8061 9.0629 15.5816 9.30446Z",
    fill: "#518EF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25672_7336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.c1110dd1336e0940ee9b72593ecccc8a.svg";
export { ForwardRef as ReactComponent };